import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('finaculator_cookie_consent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('finaculator_cookie_consent', 'accepted');
    setShow(false);
  };

  if (!show) return null;

  return (
    <Box sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'var(--bg-elevated)',
      borderTop: '1px solid var(--border-subtle)',
      p: 2,
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      zIndex: 9999,
      boxShadow: 'var(--shadow-lg)'
    }}>
      <Typography sx={{ color: 'var(--text-secondary)', fontSize: 13, fontFamily: 'Inter', flex: 1 }}>
        We use cookies and third-party services (like Google AdSense) to personalize content, serve targeted ads, and analyze our traffic. By clicking "Accept", you consent to our use of cookies. For more details, please see our <a href="/privacy" style={{ color: '#25d4ff' }}>Privacy Policy</a>.
      </Typography>
      <Button 
        onClick={handleAccept} 
        variant="contained" 
        sx={{ 
          background: 'linear-gradient(135deg, #2d84ff, #25d4ff)', 
          whiteSpace: 'nowrap',
          minWidth: 120,
          fontWeight: 600,
          textTransform: 'none'
        }}
      >
        Accept
      </Button>
    </Box>
  );
}
